var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('section',{staticClass:"order-info"},[_c('p',{staticClass:"order-label",class:{ 'ready': _vm.isReady }},[_vm._v(_vm._s(_vm.orderLabel.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"order-number",class:{ 'ready': _vm.isReady }},[_vm._v(_vm._s(('0000' + _vm.orderNumber).slice(-4)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5134b24","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/OrderInfo.vue
// module id = 101
// module chunks = 0